// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';

import styled from 'styled-components';
import { translate } from "react-i18next";

import DefaultButton from './../../../../../components/DefaultButton';

type Props = {
    visible: boolean;
    closeMenu: () => void;
    setBrightness: (value: number) => void;
    setContrast: (value: number) => void;
};

type State = {
    brightnessValue: String,
    constrastValue: String
}

const MenuWrapper = styled.div`
    display: ${props => props.visible ? 'flex' : 'none'};
    flex-direction: column;
    position: absolute;
    bottom: 5px;
    left: 5px;
    background-color: #ffffff;
    border: 1px solid #ebebeb;
    border-radius: 5px;
    padding: 5px;
`;

const initialState = {
    brightnessValue: '100',
    constrastValue: '100'
}

class ImageAdjustmentMenu extends React.Component<Props, State> {
    state = initialState

    setDefaults = () => {
        this.setState(initialState,
        () => {
            this.props.setContrast(this.state.constrastValue / 100);
            this.props.setBrightness(this.state.brightnessValue / 100);
        })
    }

    render() {
        const { visible, closeMenu, setBrightness, setContrast, t } = this.props;
        return (
            <MenuWrapper
                visible={visible}
            >
                <DefaultButton
                    style={{
                        alignSelf: 'flex-end',
                        width: '15px',
                        height: '15px',
                    }}
                    onClick={() => closeMenu()}
                >
                    X
                </DefaultButton>

                <label htmlFor="brightness">{t('Brightness')}</label>
                <input
                    type="range"
                    name="brightness"
                    min="1"
                    max="300"
                    value={this.state.brightnessValue}
                    onChange={(e) => {
                        const { value } = e.target
                        this.setState({
                            brightnessValue: value
                        })
                        setBrightness(value / 100)
                    }}
                />

                <label htmlFor="contrast">{t('Contrast')}</label>
                <input
                    type="range"
                    name="contrast"
                    min="1"
                    max="300"
                    value={this.state.constrastValue}
                    onChange={(e) => {
                        const { value } = e.target
                        this.setState({
                            constrastValue: value
                        })
                        setContrast(value / 100)
                    }}
                />

                <DefaultButton
                    style={{
                        marginTop: '10px'
                    }}
                    onClick={() => this.setDefaults()}
                >
                    {t('Default')}
                </DefaultButton>
            </MenuWrapper>
        )
    }
}

const mapStateToProps = state => ({

});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({

}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(ImageAdjustmentMenu));


// WEBPACK FOOTER //
// ./src/containers/content/grid/tilesGalleryWrapper/imageAdjustmentMenu/ImageAdjustmentMenu.jsx